import axiosInstance from "../utils/axios";

export const login = async (data) => {
    return await axiosInstance({
        method: 'post',
        url: `/login`,
        data: data,
    });
}

export const validateToken = async (data) => {
    return await axiosInstance({
        method: 'post',
        url: `../validate-token`,
        data: data,
    });
}
